import React, { useContext, useEffect, useState } from 'react'
import { useParams, Link, useLocation } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { usePlanes } from '../../context/PlanesContext'
import { NormasContext } from '../../context/NormasContext'
import "./DetalleProyecto.scss"
import Subtareas from './Subtareas'
import IndicadoresNormas from '../../components/IndicadoresNormas/IndicadoresNormas'
import ModalAuditor from '../../components/Modales/Normas/ModalAuditor'
import IllustrationAccess from "../../assets/img/access.png"
// ui
import { Modal } from 'react-bootstrap';
import { Oval } from 'react-loader-spinner'
// import Accordion from 'react-bootstrap/Accordion';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';

export const detalleProyectoContext = React.createContext()

const API_URL = process.env.REACT_APP_API_URL;

function DetalleProyecto() {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const user = jwtParse.apirest.objeto

    const location = useLocation()

    const { idConsult, id, idProyecto } = useParams()

    const { empresa, fetchEmpresa, fetchEmpresaSinConsultora } = usePlanes()
    const { 
        status,
        proyectosNormas, 
        fetchProyectosNormas,
        tareas,
        fetchTareas
    } = useContext(NormasContext)

    const [modalAuditor, setModalAuditor] = useState(false)

    const [loadingEvaluacion, setLoadingEvaluacion] = useState(false)
    const [errorFetch, setErrorFetch] = useState(null)
    const [arrEvaluaciones, setArrEvaluaciones] = useState([])
    const [modalEvaluacion, setModalEvaluacion] = useState(false)

    const [activeTaskKey, setActiveTaskKey] = useState(null); 

    useEffect(() => {
        fetchProyectosNormas({
            user,
            idEmpresa: parseInt(id)
        })

        if(parseInt(idConsult) === 0){
            fetchEmpresaSinConsultora(user, id)
        } else {
            fetchEmpresa(user, idConsult, id)
        }

        if(idProyecto){
            fetchTareas({
                idProyecto: parseInt(idProyecto)
            })
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleTaskSelect = (eventKey) => {
        setActiveTaskKey(activeTaskKey === eventKey ? null : eventKey);
    };

    let ruta;
    if(user.puesto === 1){
        ruta = `/consultora/${idConsult}/empresa/${id}`
    }
    if(user.puesto === 2){
        ruta = `/empresa/${id}`
    }
    if(user.puesto >= 3){
        ruta = ""
    }

    const proyectoSelected = proyectosNormas?.objeto?.find((e) => e.id_proyecto_norma === parseInt(idProyecto))

    const showModalAuditor = () => {
        setModalAuditor(true)
    }

    const showInforme = async (e) => {
        e.preventDefault()

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewResolucionNorma`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    idProyecto
                })
            })
            const data = await res.json()
            const errorCode = data.status ?? data.error
            setLoadingEvaluacion(true)
            if(errorCode !== 0){
                setErrorFetch(data.errorDetalle || data.codeError)
            } else {
                setArrEvaluaciones(data.objeto)
            }
            setLoadingEvaluacion(false)
            setModalEvaluacion(true)
        } catch (error) {
            setErrorFetch("Error: Conexión con backend.")
            setLoadingEvaluacion(false)
        }
    }

    const handleClose = () => {
        setModalEvaluacion(false)
        setErrorFetch(null)
        setArrEvaluaciones([])
    }

    return (
        <>
            <detalleProyectoContext.Provider value={{ user, idProyecto }}>
                <ModalAuditor show={modalAuditor} onHide={()=>setModalAuditor(false)} animation={false} dialogClassName="custom-fade-modal" />
                {/* MODAL VER EVALUACIONES */}
                <Modal 
                    show={modalEvaluacion} 
                    onHide={()=>setModalEvaluacion(false)} 
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    backdrop="static"
                    size='md' 
                    animation={false}
                >
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                            <h3 className='m-0'>Evaluaciones de auditoría</h3>
                            <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='p-3'>
                        {loadingEvaluacion ? (
                            <div className='loading__evaluaciones d-flex flex-column align-items-center justify-content-center'>
                                <Oval
                                    visible={true}
                                    height="80"
                                    width="80"
                                    color="#0d6efd"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                                <p className='fw-medium'>Loading...</p>
                            </div>
                        ) : (
                            <>
                                {errorFetch ? (
                                    <div className='modalEvaluaciones--error d-flex flex-column align-items-center justify-content-center rounded-3'>
                                        <img className='mb-4' src={IllustrationAccess} alt="" />
                                        <h2 className='text-danger mb-1'>Oops!</h2>
                                        <p className='text-center'>{errorFetch}</p>
                                    </div>
                                ) : (
                                    <>
                                        {arrEvaluaciones?.length === 0 ? (
                                            <div className='modalEvaluaciones--empty d-flex flex-column align-items-center'>
                                                <h3 className='fw-semibold text-blue-500 m-0 mb-2'>No tienes evaluaciones</h3>
                                                <p className='m-0'>El proyecto actual no ha sido evaluado por un auditor.</p>
                                            </div>
                                        ) : (
                                            <div className='modalEvaluaciones__main d-flex flex-column'>
                                                {arrEvaluaciones.map((e, i) => (
                                                    <div key={i} className='eachEvaluacion d-flex flex-row align-items-center justify-content-between mb-2'>
                                                        <div className='d-flex flex-row align-items-center'>
                                                            <i className="bi bi-file-earmark-text me-2 text-primary"></i>
                                                            <a className='me-2' href={`${API_URL}/archivos/${e.texto}`} target='_blank' rel="noreferrer">{e.texto}</a>
                                                            {e.estadoResolucion === 1 && <div className='me-2 d-flex align-items-center px-2 py-1 rounded-pill text-white fw-medium bg-success'><span className='p-0 m-0'>Aceptado</span></div>}
                                                            {e.estadoResolucion === 2 && <div className='me-2 d-flex align-items-center px-2 py-1 rounded-pill text-white fw-medium bg-danger'><span className='p-0 m-0'>Rechazado</span></div>}
                                                        </div>
                                                        <p className='m-0'>{(e.fecha_evaluacion.slice(0,10)).replace(/-/g, '/').split("/").reverse().join("/")}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Modal.Body>
                </Modal>
                <div className='detalleProyecto section'>
                    <div className='section__header d-flex flex-row align-items-end mb-4'>
                        <i className='bi bi-patch-check me-2'></i>
                        {/* BREADCRUMB ADMIN */}
                        {location.pathname.includes("consultora") && (
                            <h4 className='m-0'><Link to={'/normas'} className='breadcrumb__generico'>Normas ISO</Link> {user.puesto === 1 && <><i className="bi bi-chevron-right"></i> <Link className='breadcrumb__generico' to={`/normas${ruta}`}>{`${empresa}`}</Link></>} <i className="bi bi-chevron-right"></i> {proyectoSelected?.nombre}</h4>
                        )}
                        {/* BREADCRUMB CONSULTORAS */}
                        {(location.pathname.includes("empresa") && idConsult === undefined) && (
                            <h4 className='m-0'><Link to={'/normas'} className='breadcrumb__generico'>Normas ISO</Link> {user.puesto === 2 && <><i className="bi bi-chevron-right"></i> <Link className='breadcrumb__generico' to={`/normas${ruta}`}>{`${empresa}`}</Link></>} <i className="bi bi-chevron-right"></i> {proyectoSelected?.nombre}</h4>
                        )}
                        {/* BREADCRUMB EMPRESAS */}
                        {(location.pathname.includes("proyecto") && id === undefined) && (
                            <h4 className='m-0'><Link to={'/normas'} className='breadcrumb__generico'>Normas ISO</Link> <i className="bi bi-chevron-right"></i> {proyectoSelected?.nombre}</h4>
                        )}
                    </div>
                    {(user?.puesto < 7) && (
                        <div className='proyectoEstado d-flex flex-column flex-md-row align-items-start align-items-md-center mb-3'>
                            <div className='d-flex flex-row align-items-center'>
                                <h4 className='fw-semibold text-blue-500 m-0 me-2'>Estado del proyecto:</h4>
                                <p className='m-0'>
                                    {proyectoSelected?.estado === 1 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-warning'><span className='p-0 m-0'>En espera</span></div>}
                                    {proyectoSelected?.estado === 2 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-danger'><span className='p-0 m-0'>Rechazado</span></div>}
                                    {proyectoSelected?.estado === 3 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-success'><span className='p-0 m-0'>Aceptado</span></div>}
                                </p>
                            </div>
                            {proyectoSelected?.estado === 3 && (
                                <button onClick={showInforme} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium ms-md-2'>+ ver informe</button>
                            )}
                        </div>
                    )}
                    {(user?.puesto === 7) && (
                        <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-3'>
                            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center'>
                                <h4 className='fw-semibold text-blue-500 m-0 me-2'>Responsabilidades del auditor</h4>
                                <button 
                                    onClick={showModalAuditor}
                                    className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'
                                >Evaluación auditor</button>
                            </div>
                            {proyectoSelected?.estado && (
                                <div className='proyectoEstado d-flex flex-column flex-md-row align-items-start align-items-md-center'>
                                    <div className='d-flex flex-row align-items-center'>
                                        <h4 className='fw-semibold text-blue-500 m-0 me-2'>Estado del proyecto:</h4>
                                        <p className='m-0'>
                                            {proyectoSelected?.estado === 1 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-warning'><span className='p-0 m-0'>En espera</span></div>}
                                            {proyectoSelected?.estado === 2 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-danger'><span className='p-0 m-0'>Rechazado</span></div>}
                                            {proyectoSelected?.estado === 3 && <div className='d-flex align-items-center px-3 py-1 rounded-pill text-white fw-medium bg-success'><span className='p-0 m-0'>Aceptado</span></div>}
                                        </p>
                                    </div>
                                    {proyectoSelected?.estado === 3 && (
                                        <button onClick={showInforme} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium ms-md-2'>+ ver informe</button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    <div className={`detalleProyecto__main ${user.puesto > 5 ? 'detalleProyecto__main--ext' : ''}`}>
                        <IndicadoresNormas idProyecto={idProyecto} user={user} />
                        <div className='detalleProyecto__main__list'>
                            <h4 className='fw-semibold text-blue-500 mb-4'>Secciones de la norma</h4>
                            {status.tareas.loading ? (
                                <div className='loading__detalleProyecto d-flex flex-column align-items-center justify-content-center'>
                                    <Oval
                                        visible={true}
                                        height="80"
                                        width="80"
                                        color="#0d6efd"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                    <p className='fw-medium'>Loading...</p>
                                </div>
                            ) : (
                                <>
                                    {status.tareas.error ? (
                                        <p>{status.tareas.error}</p>
                                    ) : (
                                        <>
                                            {tareas && (
                                                // {/* <Accordion activeKey={activeTaskKey} onSelect={handleTaskSelect}>
                                                //     {tareas.map((t, i) => (
                                                //         <Accordion.Item 
                                                //             key={t.id_tarea_norma} 
                                                //             eventKey={t.id_tarea_norma.toString()}
                                                //         >
                                                //             <Accordion.Header>{t.nombre}</Accordion.Header>
                                                //             <Accordion.Body>
                                                //                 <div className='texto-descripcion'>
                                                //                     <p>{t.descripcion}</p>
                                                //                 </div>
                                                //                 {activeTaskKey === t.id_tarea_norma.toString() && (
                                                //                     <Subtareas idTarea={t.id_tarea_norma} />
                                                //                 )}
                                                //             </Accordion.Body>
                                                //         </Accordion.Item>
                                                //     ))}
                                                // </Accordion> */}
                                                <Tab.Container
                                                    activeKey={activeTaskKey}
                                                    onSelect={handleTaskSelect}
                                                >
                                                    <Row>
                                                        <Col sm={3}>
                                                            <Nav variant='pills' className='flex-column'>
                                                                {tareas.map((t) => (
                                                                    <Nav.Item key={t.id_tarea_norma}>
                                                                        <Nav.Link eventKey={t.id_tarea_norma.toString()}>
                                                                            {t.nombre}
                                                                        </Nav.Link>
                                                                    </Nav.Item>
                                                                ))}
                                                            </Nav>
                                                        </Col>
                                                        <Col sm={9}>
                                                            <Tab.Content>
                                                                {tareas.map((t) => (
                                                                    <Tab.Pane
                                                                        key={t.id_tarea_norma}
                                                                        eventKey={t.id_tarea_norma.toString()}
                                                                        className={activeTaskKey === t.id_tarea_norma.toString() ? "d-block" : "d-none"}
                                                                    >
                                                                        <div className='d-flex flex-column'>
                                                                            <h4 className='mb-2 p-0 text-blue-500 fw-medium'>Título de la sección</h4>
                                                                            <p>{t.nombre}</p>
                                                                            {t.descripcion && (
                                                                                <>
                                                                                    <h4 className='mb-2 p-0 text-blue-500 fw-medium'>Descripción de la sección</h4>
                                                                                    <p>{t.descripcion}</p>
                                                                                </>
                                                                            )}
                                                                            {activeTaskKey === t.id_tarea_norma.toString() && (
                                                                                <Subtareas idTarea={t.id_tarea_norma} />
                                                                            )}
                                                                        </div>
                                                                    </Tab.Pane>
                                                                ))}
                                                            </Tab.Content>
                                                        </Col>
                                                    </Row>
                                                </Tab.Container>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    
                </div>
            </detalleProyectoContext.Provider>
        </>
    )
}

export default DetalleProyecto